export const getCitrusUrl = () => {
  const citrusUrl = `${window.citrusEndpoint}`
  return `${citrusUrl}`
}
